import service from "@/store/services/inspection-fields-service";
import Jsona from "jsona";
import { cloneDeep } from "lodash";
import store from "..";
import { getSectionsScores, updateLinkedFields } from "../../helpers/inspectionHelper";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  inspectionField: {},
  meta: {},
  url: null,
  updatingFields: [], // Array to track fields currently being updated
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, inspectionField) => {
    state.inspectionField = inspectionField;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
  ADD_UPDATING_FIELD: (state, fieldId) => {
    if (!state.updatingFields.includes(fieldId)) {
      state.updatingFields.push(fieldId);
    }
  },
  REMOVE_UPDATING_FIELD: (state, fieldId) => {
    state.updatingFields = state.updatingFields.filter(id => id !== fieldId);
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((inspectionField) => {
      commit("SET_RESOURCE", inspectionField);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((inspectionField) => {
      commit("SET_RESOURCE", inspectionField);
    });
  },

  update({ commit, dispatch }, params) {
    // Add the field to updatingFields array
    commit("ADD_UPDATING_FIELD", params.id);

    const inspectionData = cloneDeep(store.getters["inspections/currentInspection"]);
    let inspectionField = inspectionData.inspectionFields.find((field) => field.id === params.id);
    inspectionField = { ...inspectionField, ...params };

    const fieldIndex = inspectionData.inspectionFields.findIndex((field) => field.id === params.id);
    if (fieldIndex !== -1) {
      inspectionData.inspectionFields[fieldIndex] = inspectionField;
    }

    // Update any linked fields (like corresponding tire fields)
    const linkedFields = updateLinkedFields(inspectionField, inspectionData);
    if (linkedFields.length > 0) {
      for (const linkedField of linkedFields) {
        const linkedIndex = inspectionData.inspectionFields.findIndex((field) => field.id === linkedField.id);
        if (linkedIndex !== -1) {
          inspectionData.inspectionFields[linkedIndex] = linkedField;
        }
      }
    }

    inspectionData.touched_sections = [...inspectionData.touched_sections].map(id => id.toString());
    const sectionsScores = getSectionsScores(inspectionData);
    inspectionData.sectionsScores = sectionsScores;

    store.dispatch("inspections/setCurrentInspection", inspectionData);

    params.doNotAddData = true;
    service.update(params, this.$axios)
      .then((inspectionField) => {
        commit("SET_RESOURCE", inspectionField);
        // if(inspectionField.inspectionSectionsScores) {
        //   const inspectionData = cloneDeep(store.getters["inspections/currentInspection"]);
        //   inspectionData.sectionsScores = inspectionField.inspectionSectionsScores;
        //   store.dispatch("inspections/setCurrentInspection", inspectionData);
        // }
        commit("REMOVE_UPDATING_FIELD", params.id);
        return inspectionField;
      })
      .catch((error) => {
        // Also remove from updating fields if there's an error
        commit("REMOVE_UPDATING_FIELD", params.id);
        throw error;
      });

    return new Promise((resolve) => {
      resolve();
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  inspectionField: (state) => state.inspectionField,
  url: (state) => state.url,
  updatingFields: (state) => state.updatingFields,
  isFieldUpdating: (state) => (fieldId) => state.updatingFields.includes(fieldId),
};

const inspectionFields = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default inspectionFields;
